var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Day, LocalStorageKey } from '../constants/index.js';
export const getETransferJWT = (storage, key) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const jwtData = yield storage.getItem(LocalStorageKey.ETRANSFER_ACCESS_TOKEN);
        if (!jwtData)
            return;
        const data = JSON.parse(jwtData);
        const cData = data[key];
        if (!cData || !(cData === null || cData === void 0 ? void 0 : cData.expiresTime))
            return;
        if (Date.now() + 0.5 * Day > (cData === null || cData === void 0 ? void 0 : cData.expiresTime))
            return;
        return cData;
    }
    catch (error) {
        return;
    }
});
export const resetETransferJWT = (storage) => {
    return storage.removeItem(LocalStorageKey.ETRANSFER_ACCESS_TOKEN);
};
export const setETransferJWT = (storage, key, data) => {
    const jwtData = Object.assign(Object.assign({}, data), { expiresTime: Date.now() + (data.expires_in - 10) * 1000 });
    return storage.setItem(LocalStorageKey.ETRANSFER_ACCESS_TOKEN, JSON.stringify({ [key]: jwtData }));
};
